var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.8,103.4c-2.2,3-6.3,8.9-8.4,12c-74.8,111-43.9,263.4,66.6,340.8l59.8,41.9l58.9-84.2L302.9,372 c-65.8-46.1-82.8-137.7-36.8-203.4s137.9-81,203.7-34.9l59.8,41.9l58.9-84.2l-59.8-41.9C418.3-27.9,264.5-4.9,185.8,103.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M663.8,323.1h-15.6H545.5h0H407.3h-14.6H254.5H151.8h-15.6c-24,0-43.6,24.8-43.6,55.4v365.9c0,30.6,19.6,55.6,43.6,55.6 h527.6c24,0,43.6-25,43.6-55.6V378.5C707.4,347.9,687.8,323.1,663.8,323.1z M449.4,561.1v110.6c0,12.7-10.6,23.4-23.3,23.4h-52.3 c-12.7,0-23.3-10.7-23.3-23.4V561.1c-12.3-12.1-19.4-28.8-19.4-47.3c0-35.1,27.1-65.2,61.6-66.6c3.7-0.1,11-0.1,14.6,0 c34.5,1.4,61.6,31.5,61.6,66.6C468.9,532.2,461.7,549,449.4,561.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.24afe92fb77dc27249a28a38cc474737.svg";
export { ForwardRef as ReactComponent };